import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M9 5.04165C9 2.53591 6.975.5 4.5.5S0 2.53591 0 5.04165c0 .99186.325 1.93151.9 2.71456l3.4 4.64609.04502.0455c.08623.0647.22165.0719.30498.0067l.05-.0522 3.4-4.64609.15056-.21736C8.73141 6.80189 9 5.94334 9 5.04165zm-5.96795-.33103c.17184-.81433.9451-1.35008 1.76132-1.17864.60142.12858 1.07397.5786 1.18137 1.17864.15036.81433-.38663 1.60723-1.18137 1.75724-.19332.04286-.38663.04286-.57995 0-.81622-.17144-1.3532-.94291-1.18137-1.75724z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const BrBrfsSVG = (
  <svg fill="none" viewBox="0 0 13 18" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M6.5 1.5002C3.47992 1.5002 1 3.9871 1 7.05574C1 8.26706 1.39652 9.41709 2.10301 10.3792L6.5 16.3876L10.8927 10.3851L11.0857 10.1064C11.6736 9.20312 12 8.15486 12 7.05574C12 3.9871 9.52008 1.5002 6.5 1.5002ZM0 7.05574C0 3.4424 2.92008 0.500198 6.5 0.500198C10.0799 0.500198 13 3.4424 13 7.05574C13 8.3588 12.6115 9.5979 11.9195 10.6585L11.9119 10.6701L11.7036 10.9705L7.15063 17.1919L7.03638 17.3111L7.00826 17.3332C6.69214 17.5807 6.26025 17.5307 5.99342 17.3307L5.96378 17.3085L5.85169 17.195L1.29699 10.9711C1.29686 10.9709 1.29711 10.9713 1.29699 10.9711C0.470381 9.84518 0 8.48915 0 7.05574ZM6.50023 4.70039C5.15634 4.70039 4.06689 5.78983 4.06689 7.13373C4.06689 8.47762 5.15633 9.56706 6.50023 9.56706C7.84412 9.56706 8.93356 8.47762 8.93356 7.13373C8.93356 5.78983 7.84412 4.70039 6.50023 4.70039ZM3.06689 7.13373C3.06689 5.23755 4.60405 3.70039 6.50023 3.70039C8.39641 3.70039 9.93356 5.23755 9.93356 7.13373C9.93356 9.02991 8.39641 10.5671 6.50023 10.5671C4.60405 10.5671 3.06689 9.02991 3.06689 7.13373Z"
      fill="#2D2925"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: BrBrfsSVG,
  [Brands.BananaRepublicFactoryStore]: BrBrfsSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const MapPinIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
